import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema, NoteCornSchema } from '../base.js';
export const DeleteNoteApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        noteId: NoteCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
};
export const DeleteNoteRequestSchema = DeleteNoteApiSchema.params.merge(DeleteNoteApiSchema.headers);
